import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IContentManagementAppState } from '../../../App.types';
import { ApplicationsReducerName, requestApplications } from '../Applications';

export function useApplications(applicationId: string = null) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestApplications());
  }, []);

  const state = useSelector((appState: IContentManagementAppState) => appState[ApplicationsReducerName]);
  const selectedApplication = applicationId === null ? null : state.applications?.find((p) => p.id === applicationId);

  return {
    ...state,
    selectedApplication,
  };
}
